import { Reducer } from "redux";

import { IcdCodeTypeResponse } from "../models/Api/Master";
import { IcdCodeTypeDispatchTypes } from "../models/DispatchTypes/Master";
import { IcdCodeTypeActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: IcdCodeTypeResponse = {
  loading: false,
  response: [],
};

const IcdCodeTypeReducer: Reducer<
  IcdCodeTypeResponse,
  IcdCodeTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS: {
      setLocalStorageData(
        IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default IcdCodeTypeReducer;
